import '../list/gb-list.tag.html';
import { Carousel } from './gb-carousel';
riot.tag2('gb-carousel', '<a class="gb-carousel__previous-link" onclick="{prev}">Prev</a> <gb-list items="{options}" activation="{isSelected}"> <yield></yield> </gb-list> <a class="gb-carousel__next-link" onclick="{next}">Next</a>', 'gb-carousel gb-list > ul > li:not(.active),[riot-tag="gb-carousel"] gb-list > ul > li:not(.active),[data-is="gb-carousel"] gb-list > ul > li:not(.active){ display: none; }', '', function(opts) {
    this._mixin(Carousel);
});



/** WEBPACK FOOTER **
 ** ./src/tags/carousel/gb-carousel.tag.html
 **/